module.exports = __webpack_public_path__ + "static/media/burger.9474e107.svg";